import React, { useState, Component } from 'react';
import { SearchIcon, FilterIcon, ChevronRightIcon, ChevronLeftIcon, CheckCircleIcon, ClockIcon, TruckIcon, PackageIcon, ShieldIcon, ArrowRightIcon, CalendarIcon, InfoIcon, MapPinIcon, DownloadIcon, SlidersIcon, XCircleIcon, AlertCircleIcon, ChevronDownIcon, ArrowUpDownIcon, PlusIcon, MoreHorizontalIcon, EyeIcon, FileTextIcon, RefreshCwIcon, BoxIcon, TagIcon, DollarSignIcon, BuildingIcon, UserIcon, ChevronUpIcon, ListFilterIcon, SlidersHorizontalIcon, ArrowDownIcon, ArrowUpIcon, BarChartIcon, PieChartIcon, GridIcon, ListIcon, BellIcon, HelpCircleIcon, BarChart3Icon } from 'lucide-react';
// Component for tab buttons
function TabButton({
  active,
  onClick,
  label
}) {
  return <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${active ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white' : 'text-blue-200 hover:bg-white/5'}`} onClick={onClick} data-id="element-11264">
      {label}
    </button>;
}
// Component for shipping status boxes
function ShippingStatusBox({
  status,
  label,
  date
}) {
  const getIcon = status => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon size={16} className="text-emerald-500" data-id="element-11265" />;
      case 'pending':
        return <ClockIcon size={16} className="text-gray-400" data-id="element-11266" />;
      default:
        return <AlertCircleIcon size={16} className="text-amber-500" data-id="element-11267" />;
    }
  };
  return <div className="flex flex-col items-center bg-white/5 rounded-lg p-1.5" data-id="element-11268">
      {getIcon(status)}
      <span className="text-xs text-blue-300 mt-1 text-center" data-id="element-11269">{label}</span>
      {date && <span className="text-xs text-blue-200 mt-0.5 text-center" data-id="element-11270">{date}</span>}
    </div>;
}
// Component for order cards in grid view
function OrderCard({
  order
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'shipped':
        return 'text-emerald-500';
      case 'scheduled':
        return 'text-blue-500';
      case 'pending':
        return 'text-amber-500';
      case 'canceled':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };
  const getStatusBg = status => {
    switch (status) {
      case 'shipped':
        return 'bg-emerald-500/20';
      case 'scheduled':
        return 'bg-blue-500/20';
      case 'pending':
        return 'bg-amber-500/20';
      case 'canceled':
        return 'bg-red-500/20';
      default:
        return 'bg-gray-500/20';
    }
  };
  const getStatusIcon = status => {
    switch (status) {
      case 'shipped':
        return <TruckIcon size={14} data-id="element-11271" />;
      case 'scheduled':
        return <CalendarIcon size={14} data-id="element-11272" />;
      case 'pending':
        return <ClockIcon size={14} data-id="element-11273" />;
      case 'canceled':
        return <XCircleIcon size={14} data-id="element-11274" />;
      default:
        return <InfoIcon size={14} data-id="element-11275" />;
    }
  };
  return <div className="bg-gradient-to-br from-white/5 to-white/10 rounded-lg overflow-hidden border border-white/10 hover:border-white/20 transition-colors" data-id="element-11276">
      <div className="p-4 border-b border-white/10" data-id="element-11277">
        <div className="flex justify-between items-start mb-3" data-id="element-11278">
          <div className="font-medium text-white" data-id="element-11279">{order.id}</div>
          <div className={`px-2.5 py-1 rounded-full text-xs font-medium capitalize flex items-center ${getStatusBg(order.status)} ${getStatusColor(order.status)}`} data-id="element-11280">
            {getStatusIcon(order.status)}
            <span className="ml-1" data-id="element-11281">{order.status}</span>
          </div>
        </div>
        <div className="text-sm text-blue-300 flex items-center mb-3" data-id="element-11282">
          <CalendarIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11283" />
          {order.date}
        </div>
        <div className="flex justify-between items-end" data-id="element-11284">
          <div data-id="element-11285">
            <div className="text-xs text-blue-300 mb-1" data-id="element-11286">Products</div>
            <div className="text-sm text-white" data-id="element-11287">{order.products}</div>
          </div>
          <div className="text-right" data-id="element-11288">
            <div className="text-xs text-blue-300 mb-1" data-id="element-11289">Amount</div>
            <div className="text-sm font-medium text-white" data-id="element-11290">{order.amount}</div>
          </div>
        </div>
      </div>
      <div className="p-4 bg-blue-950/30" data-id="element-11291">
        <div className="mb-3" data-id="element-11292">
          <div className="text-xs text-blue-300 mb-1" data-id="element-11293">Bill by</div>
          <div className="text-sm text-white" data-id="element-11294">{order.billBy}</div>
        </div>
        <div className="mb-4" data-id="element-11295">
          <div className="text-xs text-blue-300 mb-1" data-id="element-11296">Bill to</div>
          <div className="text-sm text-white truncate" data-id="element-11297">{order.billTo}</div>
        </div>
        <div className="flex justify-between" data-id="element-11298">
          <button className="px-3 py-1.5 text-xs bg-white/10 text-blue-200 rounded hover:bg-white/20 hover:text-white transition-colors" data-id="element-11299">
            <FileTextIcon size={14} className="mr-1" data-id="element-11300" />
            Invoice
          </button>
          <button className="px-3 py-1.5 text-xs bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded hover:from-blue-700 hover:to-indigo-700 transition-colors" data-id="element-11301">
            <EyeIcon size={14} className="mr-1" data-id="element-11302" />
            Details
          </button>
        </div>
      </div>
    </div>;
}
// Empty state component
function EmptyState({
  onClearFilters,
  className = ''
}) {
  return <div className={`p-8 text-center ${className}`} data-id="element-11303">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-900/20 mb-4" data-id="element-11304">
        <SearchIcon size={24} className="text-blue-400" data-id="element-11305" />
      </div>
      <h3 className="text-lg font-medium text-white mb-2" data-id="element-11306">No orders found</h3>
      <p className="text-blue-300 max-w-md mx-auto" data-id="element-11307">
        We couldn't find any orders matching your current filters. Try adjusting
        your search criteria or clear all filters.
      </p>
      <button className="mt-4 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-colors" onClick={onClearFilters} data-id="element-11308">
        Clear All Filters
      </button>
    </div>;
}
export function OrdersPage() {
  const [activeTab, setActiveTab] = useState('active');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // list or grid
  const [sortField, setSortField] = useState('date');
  const [sortDirection, setSortDirection] = useState('desc');
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    status: [],
    region: [],
    dateRange: 'all'
  });
  // Mock data for orders
  const orders = [{
    id: 'Q4ZESF',
    status: 'scheduled',
    date: 'Jul 22, 2025',
    billBy: 'Aisco AMERICA',
    billTo: 'VK SALES & SERVICE',
    products: '2 pivots',
    amount: '$ 174,650.94',
    region: 'America',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jul 24, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jul 24, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 24, 2025'
      },
      shipping: {
        status: 'pending',
        date: 'Jul 30, 2025'
      }
    }
  }, {
    id: 'UMRX5S',
    status: 'shipped',
    date: 'Jul 9, 2025',
    billBy: 'Walsh Auto Supply',
    billTo: 'Walsh Auto Supply',
    products: '2 pivots',
    amount: '$ 302,903.41',
    region: 'America',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      shipping: {
        status: 'completed',
        date: 'Jul 17, 2025'
      }
    }
  }, {
    id: '7IIT03',
    status: 'shipped',
    date: 'Jul 8, 2025',
    billBy: 'Aisco EUROPE',
    billTo: 'IMPER REGAS Lda (Olivenza, Badajoz, España)',
    products: '1 pivot',
    amount: '53,520.49 €',
    region: 'Europe',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jul 8, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jul 8, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      shipping: {
        status: 'completed',
        date: 'Jul 17, 2025'
      }
    }
  }, {
    id: 'H93M5H',
    status: 'shipped',
    date: 'Jun 27, 2025',
    billBy: 'Aisco AMERICA',
    billTo: 'VK SALES & SERVICE',
    products: '4 pivots',
    amount: '$ 249,467.60',
    region: 'America',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jun 30, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jun 30, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 7, 2025'
      },
      shipping: {
        status: 'completed',
        date: 'Jul 18, 2025'
      }
    }
  }, {
    id: '6URMLZ',
    status: 'pending',
    date: 'Jun 25, 2025',
    billBy: 'CAN AGRO LLP',
    billTo: 'АФ ВЕДЕНОВКА (Очередь 3 v2)',
    products: '7 pivots',
    amount: '$ 477,917.06',
    region: 'Europe',
    shipping: {
      approved: {
        status: 'pending',
        date: ''
      },
      acknowledgment: {
        status: 'pending',
        date: ''
      },
      readyToLoad: {
        status: 'pending',
        date: ''
      },
      shipping: {
        status: 'pending',
        date: ''
      }
    }
  }, {
    id: 'U4OLLY',
    status: 'pending',
    date: 'Jun 18, 2025',
    billBy: 'DAIRY GLOBAL EXPERTS LLC',
    billTo: 'ПСП ВІКТОРІЯ',
    products: '1 pivot',
    amount: '$ 43,228.92',
    region: 'Europe',
    shipping: {
      approved: {
        status: 'pending',
        date: ''
      },
      acknowledgment: {
        status: 'pending',
        date: ''
      },
      readyToLoad: {
        status: 'pending',
        date: ''
      },
      shipping: {
        status: 'pending',
        date: ''
      }
    }
  }];
  // Filter and sort orders
  const filteredOrders = orders.filter(order => {
    // Filter by search query
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return order.id.toLowerCase().includes(query) || order.billBy.toLowerCase().includes(query) || order.billTo.toLowerCase().includes(query) || order.products.toLowerCase().includes(query);
    }
    // Filter by status
    if (selectedFilters.status.length > 0 && !selectedFilters.status.includes(order.status)) {
      return false;
    }
    // Filter by region
    if (selectedFilters.region.length > 0 && !selectedFilters.region.includes(order.region)) {
      return false;
    }
    // Filter by tab
    if (activeTab === 'active' && order.status === 'canceled') {
      return false;
    } else if (activeTab === 'closed' && order.status !== 'shipped') {
      return false;
    } else if (activeTab === 'canceled' && order.status !== 'canceled') {
      return false;
    }
    return true;
  });
  // Sort orders
  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (sortField === 'date') {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    } else if (sortField === 'amount') {
      const amountA = parseFloat(a.amount.replace(/[^0-9.-]+/g, ''));
      const amountB = parseFloat(b.amount.replace(/[^0-9.-]+/g, ''));
      return sortDirection === 'asc' ? amountA - amountB : amountB - amountA;
    } else if (sortField === 'id') {
      return sortDirection === 'asc' ? a.id.localeCompare(b.id) : b.id.localeCompare(a.id);
    }
    return 0;
  });
  const getStatusColor = status => {
    switch (status) {
      case 'shipped':
        return 'text-emerald-500';
      case 'scheduled':
        return 'text-blue-500';
      case 'pending':
        return 'text-amber-500';
      case 'canceled':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };
  const getStatusBg = status => {
    switch (status) {
      case 'shipped':
        return 'bg-emerald-500/20';
      case 'scheduled':
        return 'bg-blue-500/20';
      case 'pending':
        return 'bg-amber-500/20';
      case 'canceled':
        return 'bg-red-500/20';
      default:
        return 'bg-gray-500/20';
    }
  };
  const getStatusIcon = status => {
    switch (status) {
      case 'shipped':
        return <TruckIcon size={14} data-id="element-11309" />;
      case 'scheduled':
        return <CalendarIcon size={14} data-id="element-11310" />;
      case 'pending':
        return <ClockIcon size={14} data-id="element-11311" />;
      case 'canceled':
        return <XCircleIcon size={14} data-id="element-11312" />;
      default:
        return <InfoIcon size={14} data-id="element-11313" />;
    }
  };
  const getShippingStatusIcon = status => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon size={16} className="text-emerald-500" data-id="element-11314" />;
      case 'pending':
        return <ClockIcon size={16} className="text-gray-400" data-id="element-11315" />;
      default:
        return <AlertCircleIcon size={16} className="text-amber-500" data-id="element-11316" />;
    }
  };
  const handleOrderClick = id => {
    setExpandedOrder(expandedOrder === id ? null : id);
  };
  const toggleSort = field => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('desc');
    }
  };
  const toggleFilter = (type, value) => {
    setSelectedFilters(prev => {
      const newFilters = {
        ...prev
      };
      if (type === 'dateRange') {
        newFilters.dateRange = value;
      } else {
        if (newFilters[type].includes(value)) {
          newFilters[type] = newFilters[type].filter(item => item !== value);
        } else {
          newFilters[type] = [...newFilters[type], value];
        }
      }
      return newFilters;
    });
  };
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-11317">
      {/* Header with navigation */}
      <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-11318">
        <div className="px-6 py-4 flex justify-between items-center" data-id="element-11319">
          <div className="flex items-center" data-id="element-11320">
            <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-11321">
              <TruckIcon size={20} className="text-white" data-id="element-11322" />
            </div>
            <div data-id="element-11323">
              <h1 className="text-xl font-bold text-white" data-id="element-11324">Orders</h1>
              <p className="text-blue-200 text-sm hidden sm:block" data-id="element-11325">
                Manage and track all your orders
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-11326">
            <div className="relative hidden sm:block" data-id="element-11327">
              <div className="relative" data-id="element-11328">
                <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-11329" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-11330" />
              </div>
            </div>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11331">
              <CalendarIcon size={20} data-id="element-11332" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11333">
              <BarChart3Icon size={20} data-id="element-11334" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11335">
              <HelpCircleIcon size={20} data-id="element-11336" />
            </button>
            <div className="relative" data-id="element-11337">
              <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11338">
                <BellIcon size={20} data-id="element-11339" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-11340">
                  3
                </span>
              </button>
            </div>
            <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-11341">
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-11342">
                <UserIcon size={16} className="text-white" data-id="element-11343" />
              </div>
              <span className="text-white text-sm font-medium hidden sm:block" data-id="element-11344">
                Daniel Alejandro
              </span>
              <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-11345" />
            </div>
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-lg flex items-center" data-id="element-11346">
              <PlusIcon size={16} className="mr-2" data-id="element-11347" />
              New Order
            </button>
          </div>
        </div>
      </header>
      {/* Main content */}
      <div className="p-4 md:p-6" data-id="element-11348">
        <div className="bg-white/5 backdrop-blur-md rounded-xl border border-white/10 overflow-hidden shadow-xl" data-id="element-11349">
          {/* Tabs and search */}
          <div className="flex flex-col md:flex-row md:items-center justify-between border-b border-white/10 p-4" data-id="element-11350">
            <div className="flex space-x-1 mb-4 md:mb-0" data-id="element-11351">
              <TabButton active={activeTab === 'active'} onClick={() => setActiveTab('active')} label="Active orders" data-id="element-11352" />
              <TabButton active={activeTab === 'closed'} onClick={() => setActiveTab('closed')} label="Closed orders" data-id="element-11353" />
              <TabButton active={activeTab === 'canceled'} onClick={() => setActiveTab('canceled')} label="Canceled orders" data-id="element-11354" />
            </div>
            <div className="flex space-x-2" data-id="element-11355">
              <div className="relative flex-grow" data-id="element-11356">
                <input type="text" placeholder="Search by code, name, dealer, customer..." className="w-full md:w-80 bg-white/5 border border-white/10 rounded-lg pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-11357" />
                <SearchIcon className="absolute left-3 top-2.5 text-blue-300" size={16} data-id="element-11358" />
              </div>
              <button className={`p-2 rounded-lg ${filtersOpen ? 'bg-blue-600 text-white' : 'bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white'} transition-colors`} onClick={() => setFiltersOpen(!filtersOpen)} data-id="element-11359">
                <FilterIcon size={16} data-id="element-11360" />
              </button>
              <button className="p-2 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-11361">
                <DownloadIcon size={16} data-id="element-11362" />
              </button>
              <div className="hidden md:flex space-x-2" data-id="element-11363">
                <button className={`p-2 rounded-lg transition-colors ${viewMode === 'list' ? 'bg-blue-600 text-white' : 'bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white'}`} onClick={() => setViewMode('list')} data-id="element-11364">
                  <ListIcon size={16} data-id="element-11365" />
                </button>
                <button className={`p-2 rounded-lg transition-colors ${viewMode === 'grid' ? 'bg-blue-600 text-white' : 'bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white'}`} onClick={() => setViewMode('grid')} data-id="element-11366">
                  <GridIcon size={16} data-id="element-11367" />
                </button>
              </div>
            </div>
          </div>
          {/* Filters panel */}
          {filtersOpen && <div className="bg-gradient-to-r from-blue-900/30 to-indigo-900/30 border-b border-white/10 p-4" data-id="element-11368">
              <div className="flex flex-wrap gap-4" data-id="element-11369">
                <div data-id="element-11370">
                  <h3 className="text-sm font-medium text-white mb-2" data-id="element-11371">
                    Status
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-11372">
                    {['pending', 'scheduled', 'shipped', 'canceled'].map(status => <button key={status} className={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize flex items-center space-x-1.5 ${selectedFilters.status.includes(status) ? `${getStatusBg(status)} ${getStatusColor(status)}` : 'bg-white/5 text-blue-200 hover:bg-white/10'}`} onClick={() => toggleFilter('status', status)} data-id="element-11373">
                          <span data-id="element-11374">{getStatusIcon(status)}</span>
                          <span data-id="element-11375">{status}</span>
                          {selectedFilters.status.includes(status) && <XCircleIcon size={12} data-id="element-11376" />}
                        </button>)}
                  </div>
                </div>
                <div data-id="element-11377">
                  <h3 className="text-sm font-medium text-white mb-2" data-id="element-11378">
                    Region
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-11379">
                    {['America', 'Europe', 'Asia', 'ANZ'].map(region => <button key={region} className={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize flex items-center space-x-1.5 ${selectedFilters.region.includes(region) ? 'bg-indigo-500/20 text-indigo-300' : 'bg-white/5 text-blue-200 hover:bg-white/10'}`} onClick={() => toggleFilter('region', region)} data-id="element-11380">
                        <MapPinIcon size={12} data-id="element-11381" />
                        <span data-id="element-11382">{region}</span>
                        {selectedFilters.region.includes(region) && <XCircleIcon size={12} data-id="element-11383" />}
                      </button>)}
                  </div>
                </div>
                <div data-id="element-11384">
                  <h3 className="text-sm font-medium text-white mb-2" data-id="element-11385">
                    Date Range
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-11386">
                    {[{
                  id: 'all',
                  label: 'All Time'
                }, {
                  id: 'today',
                  label: 'Today'
                }, {
                  id: 'week',
                  label: 'This Week'
                }, {
                  id: 'month',
                  label: 'This Month'
                }, {
                  id: 'quarter',
                  label: 'This Quarter'
                }].map(range => <button key={range.id} className={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize flex items-center space-x-1.5 ${selectedFilters.dateRange === range.id ? 'bg-blue-500/20 text-blue-300' : 'bg-white/5 text-blue-200 hover:bg-white/10'}`} onClick={() => toggleFilter('dateRange', range.id)} data-id="element-11387">
                        <CalendarIcon size={12} data-id="element-11388" />
                        <span data-id="element-11389">{range.label}</span>
                      </button>)}
                  </div>
                </div>
              </div>
              <div className="flex justify-between mt-4 pt-4 border-t border-white/5" data-id="element-11390">
                <button className="px-3 py-1.5 rounded-lg text-xs font-medium bg-white/5 text-blue-200 hover:bg-white/10 transition-colors" onClick={() => setSelectedFilters({
              status: [],
              region: [],
              dateRange: 'all'
            })} data-id="element-11391">
                  Clear All Filters
                </button>
                <div className="text-sm text-blue-300" data-id="element-11392">
                  Showing{' '}
                  <span className="font-medium text-white" data-id="element-11393">
                    {sortedOrders.length}
                  </span>{' '}
                  of{' '}
                  <span className="font-medium text-white" data-id="element-11394">
                    {orders.length}
                  </span>{' '}
                  orders
                </div>
              </div>
            </div>}
          {viewMode === 'list' ? <>
              {/* Table header */}
              <div className="hidden md:grid grid-cols-12 gap-2 p-4 text-xs font-medium text-blue-300 border-b border-white/10" data-id="element-11395">
                <div className="col-span-1" data-id="element-11396">Status</div>
                <div className="col-span-2 flex items-center cursor-pointer group" onClick={() => toggleSort('id')} data-id="element-11397">
                  Code / Date
                  <button className="ml-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-11398">
                    {sortField === 'id' ? sortDirection === 'asc' ? <ArrowUpIcon size={12} data-id="element-11399" /> : <ArrowDownIcon size={12} data-id="element-11400" /> : <ArrowUpDownIcon size={12} data-id="element-11401" />}
                  </button>
                </div>
                <div className="col-span-3" data-id="element-11402">Bill by / Bill to</div>
                <div className="col-span-2" data-id="element-11403">Products</div>
                <div className="col-span-3" data-id="element-11404">Shipping schedule</div>
                <div className="col-span-1 text-right" data-id="element-11405">Actions</div>
              </div>
              {/* Table content */}
              <div className="divide-y divide-white/10" data-id="element-11406">
                {sortedOrders.length > 0 ? sortedOrders.map(order => <div key={order.id} className="group" data-id="element-11407">
                      <div className="grid grid-cols-1 md:grid-cols-12 gap-2 p-4 hover:bg-white/5 cursor-pointer transition-colors" onClick={() => handleOrderClick(order.id)} data-id="element-11408">
                        {/* Status - Mobile & Desktop */}
                        <div className="col-span-1 flex md:block items-center justify-between" data-id="element-11409">
                          <div className={`flex items-center space-x-1.5 ${getStatusColor(order.status)}`} data-id="element-11410">
                            <span className={`p-1 rounded-md ${getStatusBg(order.status)}`} data-id="element-11411">
                              {getStatusIcon(order.status)}
                            </span>
                            <span className="capitalize font-medium" data-id="element-11412">
                              {order.status}
                            </span>
                          </div>
                          <button className="md:hidden p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-11413">
                            <ChevronRightIcon size={16} className={`transition-transform ${expandedOrder === order.id ? 'rotate-90' : ''}`} data-id="element-11414" />
                          </button>
                        </div>
                        {/* Code & Date - Desktop */}
                        <div className="col-span-2 hidden md:block" data-id="element-11415">
                          <div className="font-medium text-white" data-id="element-11416">
                            {order.id}
                          </div>
                          <div className="text-sm text-blue-300 flex items-center mt-1" data-id="element-11417">
                            <CalendarIcon size={14} className="mr-1.5" data-id="element-11418" />
                            {order.date}
                          </div>
                        </div>
                        {/* Code & Date - Mobile */}
                        <div className="md:hidden flex justify-between items-center" data-id="element-11419">
                          <div data-id="element-11420">
                            <div className="font-medium text-white" data-id="element-11421">
                              {order.id}
                            </div>
                            <div className="text-sm text-blue-300 flex items-center mt-1" data-id="element-11422">
                              <CalendarIcon size={14} className="mr-1.5" data-id="element-11423" />
                              {order.date}
                            </div>
                          </div>
                        </div>
                        {/* Bill by / Bill to - Desktop */}
                        <div className="col-span-3 hidden md:block" data-id="element-11424">
                          <div className="font-medium text-white flex items-center" data-id="element-11425">
                            <BuildingIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11426" />
                            {order.billBy}
                          </div>
                          <div className="text-sm text-blue-300 mt-1 flex items-center" data-id="element-11427">
                            <UserIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11428" />
                            <span className="truncate" data-id="element-11429">{order.billTo}</span>
                          </div>
                        </div>
                        {/* Products - Desktop */}
                        <div className="col-span-2 hidden md:flex flex-col" data-id="element-11430">
                          <div className="font-medium text-white flex items-center" data-id="element-11431">
                            <BoxIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11432" />
                            {order.products}
                          </div>
                          <div className="text-sm text-blue-300 mt-1 flex items-center" data-id="element-11433">
                            <TagIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11434" />
                            {order.amount}
                          </div>
                        </div>
                        {/* Shipping schedule - Desktop */}
                        <div className="col-span-3 hidden md:block" data-id="element-11435">
                          <div className="grid grid-cols-4 gap-1" data-id="element-11436">
                            <ShippingStatusBox status={order.shipping.approved.status} label="Approved" date={order.shipping.approved.date} data-id="element-11437" />
                            <ShippingStatusBox status={order.shipping.acknowledgment.status} label="Ack." date={order.shipping.acknowledgment.date} data-id="element-11438" />
                            <ShippingStatusBox status={order.shipping.readyToLoad.status} label="Ready" date={order.shipping.readyToLoad.date} data-id="element-11439" />
                            <ShippingStatusBox status={order.shipping.shipping.status} label="Ship" date={order.shipping.shipping.date} data-id="element-11440" />
                          </div>
                        </div>
                        {/* Actions - Desktop */}
                        <div className="col-span-1 flex justify-end items-start space-x-1 hidden md:flex" data-id="element-11441">
                          <button className="p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-11442">
                            <EyeIcon size={16} data-id="element-11443" />
                          </button>
                          <button className="p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-11444">
                            <FileTextIcon size={16} data-id="element-11445" />
                          </button>
                          <button className="p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-11446">
                            <MoreHorizontalIcon size={16} data-id="element-11447" />
                          </button>
                        </div>
                      </div>
                      {/* Expanded view */}
                      {expandedOrder === order.id && <div className="bg-gradient-to-r from-blue-900/30 to-indigo-900/30 p-4 border-t border-white/10" data-id="element-11448">
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-11449">
                            <div className="bg-white/5 rounded-lg p-4" data-id="element-11450">
                              <h3 className="text-sm font-medium text-white mb-3 flex items-center" data-id="element-11451">
                                <InfoIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11452" />
                                Order Details
                              </h3>
                              <div className="space-y-3" data-id="element-11453">
                                <div className="flex justify-between" data-id="element-11454">
                                  <span className="text-sm text-blue-300" data-id="element-11455">
                                    Order ID:
                                  </span>
                                  <span className="text-sm text-white font-medium" data-id="element-11456">
                                    {order.id}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11457">
                                  <span className="text-sm text-blue-300" data-id="element-11458">
                                    Order Date:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11459">
                                    {order.date}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11460">
                                  <span className="text-sm text-blue-300" data-id="element-11461">
                                    Status:
                                  </span>
                                  <span className={`text-sm font-medium capitalize ${getStatusColor(order.status)}`} data-id="element-11462">
                                    {order.status}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11463">
                                  <span className="text-sm text-blue-300" data-id="element-11464">
                                    Amount:
                                  </span>
                                  <span className="text-sm text-white font-medium" data-id="element-11465">
                                    {order.amount}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11466">
                                  <span className="text-sm text-blue-300" data-id="element-11467">
                                    Region:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11468">
                                    {order.region}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="bg-white/5 rounded-lg p-4" data-id="element-11469">
                              <h3 className="text-sm font-medium text-white mb-3 flex items-center" data-id="element-11470">
                                <BuildingIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11471" />
                                Billing Information
                              </h3>
                              <div className="space-y-3" data-id="element-11472">
                                <div className="flex justify-between" data-id="element-11473">
                                  <span className="text-sm text-blue-300" data-id="element-11474">
                                    Bill by:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11475">
                                    {order.billBy}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11476">
                                  <span className="text-sm text-blue-300" data-id="element-11477">
                                    Bill to:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11478">
                                    {order.billTo}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11479">
                                  <span className="text-sm text-blue-300" data-id="element-11480">
                                    Products:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11481">
                                    {order.products}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="bg-white/5 rounded-lg p-4" data-id="element-11482">
                              <h3 className="text-sm font-medium text-white mb-3 flex items-center" data-id="element-11483">
                                <TruckIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11484" />
                                Shipping Timeline
                              </h3>
                              <div className="space-y-3" data-id="element-11485">
                                <div className="flex items-center" data-id="element-11486">
                                  {getShippingStatusIcon(order.shipping.approved.status)}
                                  <div className="ml-2" data-id="element-11487">
                                    <div className="text-sm text-white" data-id="element-11488">
                                      Approved
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-11489">
                                      {order.shipping.approved.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center" data-id="element-11490">
                                  {getShippingStatusIcon(order.shipping.acknowledgment.status)}
                                  <div className="ml-2" data-id="element-11491">
                                    <div className="text-sm text-white" data-id="element-11492">
                                      Acknowledgment
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-11493">
                                      {order.shipping.acknowledgment.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center" data-id="element-11494">
                                  {getShippingStatusIcon(order.shipping.readyToLoad.status)}
                                  <div className="ml-2" data-id="element-11495">
                                    <div className="text-sm text-white" data-id="element-11496">
                                      Ready to load
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-11497">
                                      {order.shipping.readyToLoad.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center" data-id="element-11498">
                                  {getShippingStatusIcon(order.shipping.shipping.status)}
                                  <div className="ml-2" data-id="element-11499">
                                    <div className="text-sm text-white" data-id="element-11500">
                                      Shipping
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-11501">
                                      {order.shipping.shipping.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-end mt-4 space-x-2" data-id="element-11502">
                            <button className="px-3 py-1.5 text-sm bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors" data-id="element-11503">
                              Download Invoice
                            </button>
                            <button className="px-3 py-1.5 text-sm bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-colors" data-id="element-11504">
                              View Details
                            </button>
                          </div>
                        </div>}
                    </div>) : <EmptyState onClearFilters={() => setSelectedFilters({
              status: [],
              region: [],
              dateRange: 'all'
            })} data-id="element-11505" />}
              </div>
            </> :
        // Grid view
        <div className="p-4" data-id="element-11506">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-11507">
                {sortedOrders.length > 0 ? sortedOrders.map(order => <OrderCard key={order.id} order={order} data-id="element-11508" />) : <EmptyState onClearFilters={() => setSelectedFilters({
              status: [],
              region: [],
              dateRange: 'all'
            })} className="col-span-full" data-id="element-11509" />}
              </div>
            </div>}
          {/* Pagination */}
          {sortedOrders.length > 0 && <div className="flex items-center justify-between p-4 border-t border-white/10" data-id="element-11510">
              <div className="text-sm text-blue-300" data-id="element-11511">
                Showing{' '}
                <span className="font-medium text-white" data-id="element-11512">
                  {sortedOrders.length}
                </span>{' '}
                of{' '}
                <span className="font-medium text-white" data-id="element-11513">{orders.length}</span>{' '}
                orders
              </div>
              <div className="flex items-center space-x-1" data-id="element-11514">
                <button className="p-2 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-11515">
                  <ChevronLeftIcon size={16} data-id="element-11516" />
                </button>
                <button className="w-8 h-8 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white flex items-center justify-center" data-id="element-11517">
                  1
                </button>
                <button className="w-8 h-8 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center" data-id="element-11518">
                  2
                </button>
                <button className="w-8 h-8 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center" data-id="element-11519">
                  3
                </button>
                <button className="w-8 h-8 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center" data-id="element-11520">
                  4
                </button>
                <button className="p-2 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-11521">
                  <ChevronRightIcon size={16} data-id="element-11522" />
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}